import { CardForm } from '@components/atoms';
import { HTMLAttributes, ReactNode } from 'react';

interface GenericCardProps extends HTMLAttributes<HTMLDivElement> {
	title?: string;
	icon?: ReactNode;
	children?: ReactNode;
	subtitle?: string;
	className?: string;
	onClick?: () => void;
}

export const GenericCard = ({
	title,
	children,
	icon,
	subtitle,
	className,
	...props
}: GenericCardProps) => (
	<CardForm data-testid='generic-card' className={className} {...props}>
		<div className='flex flex-col space-y-2 items-center text-center'>
			{icon && <div className=' text-primary text-4xl'>{icon}</div>}

			{title && <h2 className='text-lg font-semibold'>{title}</h2>}

			{subtitle && (
				<p className='bg-primary text-white m-0 px-4 py-1 rounded-full text-xs'>
					{subtitle}
				</p>
			)}
		</div>

		{children}
	</CardForm>
);
